export const MARKET_ID = "marketId";

export const TOKEN = "token";
export const USER_ID = "userId";
export const USER_SIGN = "userSign";
export const USER_INFO = "userInfo";
export const USER_NAME = "userName";
export const USER_PWD = "userPwd";
export const TIMESTAMP = "timestamp";
export const LOCAL_LANGUAGE = "local_language";
export const ACTIVE_ROUTE_INDEX = "ACTIVE_ROUTE_INDEX";
export const UPDATE_PWD_TIME = 'agent_update_pwd_time';
export const UPDATE_PWD_TIME_CANCEL = 'agent_update_pwd_time_cancel';
export const LOGIN_TYPE = 'gent_login_type';





//////////////////
// WEBPACK FOOTER
// ./api/localStorageName.js
// module id = 4vIY
// module chunks = 28